import React from 'react';
import { BarChart3, RefreshCw, Download, Loader2 } from 'lucide-react';

interface Props {
  qtdeBoletosNoFiltro: number;
  ultimaAtualizacao: Date | null;
  loading: boolean;
  onAtualizar: () => void;
  exportando: boolean;
  onExportar: () => void;
}

const FaixaMarca: React.FC<Props> = ({ qtdeBoletosNoFiltro, ultimaAtualizacao, loading, onAtualizar, exportando, onExportar }) => {
  return (
    <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
      <div>
        <h2 className="text-2xl font-poppins font-bold dark:text-white flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-primary to-primary-dark flex items-center justify-center shadow-lg shadow-primary/20">
            <BarChart3 size={20} className="text-white" />
          </div>
          Painel Financeiro Executivo
        </h2>
        <p className="text-sm text-gray-500 dark:text-gray-400 mt-1 ml-[52px]">
          {qtdeBoletosNoFiltro.toLocaleString('pt-BR')} boletos no filtro atual · Última atualização:{' '}
          {ultimaAtualizacao ? ultimaAtualizacao.toLocaleString('pt-BR') : '—'}
        </p>
      </div>

      <div className="flex flex-wrap items-center gap-2">
        <button
          onClick={onExportar}
          disabled={exportando || loading || qtdeBoletosNoFiltro === 0}
          title="Baixa um Excel com resumo, boletos emitidos (mesmo total do card), evolução mensal, aging e maiores devedores do filtro atual"
          className="flex items-center gap-1.5 px-4 py-2 rounded-xl text-sm font-semibold bg-primary text-white hover:bg-primary-dark shadow-sm transition-colors disabled:opacity-50"
        >
          {exportando ? <Loader2 size={15} className="animate-spin" /> : <Download size={15} />}
          Exportar Excel
        </button>
        <button
          onClick={onAtualizar}
          disabled={loading}
          className="flex items-center gap-1.5 px-4 py-2 rounded-xl text-sm font-semibold bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 shadow-sm transition-colors disabled:opacity-50"
        >
          <RefreshCw size={15} className={loading ? 'animate-spin' : ''} />
          Atualizar dados
        </button>
      </div>
    </div>
  );
};

export default FaixaMarca;
